import React from "react";
import { Subscription } from "react-apollo";
import gql from "graphql-tag";
import MachineStatus from "components/MachineStatus/MachineStatus";
import { PlantItem } from "components/StyledComponents";
import { httpClient } from "settings/apolloClient";
import SUBSCRIBE_TO_ACTUATOR_CHANGES from "../graphql/subscriptions/subscribeToActuatorStatusChanges.js";

// Live status is kept in the (httpClient) normalized cache so a single source
// of truth drives the panel: the initial PLANT_LOCATIONS fetch seeds the
// status and each subscription event patches the same Actuator entry. This
// removes the need to poll PLANT_LOCATIONS and fixes stale/lost actuator state
// on reload and after a websocket reconnect.
const ACTUATOR_LIVE_STATUS = gql`
  fragment ActuatorLiveStatus on Actuator {
    status
  }
`;

const writeActuatorStatus = (id, status) => {
  if (status === undefined || status === null) return;

  try {
    httpClient.writeFragment({
      id: `Actuator:${id}`,
      fragment: ACTUATOR_LIVE_STATUS,
      data: {
        __typename: "Actuator",
        status,
      },
    });
  } catch (error) {
    // no-op: the actuator is not in the cache yet (query still loading)
  }
};

// The Subscription renders nothing: it exists only to run the subscription and
// patch the cache via onSubscriptionData. The displayed status comes from the
// props (fed by the cache-backed PLANT_LOCATIONS query), so MachineStatus is a
// sibling in the normal return. Keeping status JSX out of the render-prop arrow
// also avoids a production babel bug (transform-react-constant-elements hoisting
// a prop-only element out of the nested arrow).
const ActuatorSubscription = ({
  automationStatus,
  id,
  name,
  status,
  type,
  maintenanceMode,
}) => (
  <PlantItem>
    <Subscription
      subscription={SUBSCRIBE_TO_ACTUATOR_CHANGES}
      fetchPolicy="no-cache"
      variables={{
        id
      }}
      onSubscriptionData={({ subscriptionData }) => {
        const next = subscriptionData
          && subscriptionData.data
          && subscriptionData.data.subscribeToActuatorStatusChanges;

        writeActuatorStatus(id, next);
      }}
    >
      {() => null}
    </Subscription>
    <MachineStatus
      automationStatus={automationStatus}
      status={status}
      actuatorName={name}
      id={id}
      type={type}
      maintenanceMode={maintenanceMode}
    />
  </PlantItem>
);

export default ActuatorSubscription;
